import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Global auth redirect hook — handles OAuth callbacks (Google etc.)
 * that land on "/" or other non-auth pages after sign-in.
 */
export function useAuthRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const handled = useRef(false);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (handled.current) return;

        // Only handle fresh sign-ins landing on public pages
        if (event === "SIGNED_IN" && session) {
          const path = location.pathname;
          const isPublicPage =
            path === "/" ||
            path === "/login" ||
            path === "/signup" ||
            path === "/compare" ||
            path.startsWith("/blog");

          if (!isPublicPage) return;

          handled.current = true;

          // Check if user has completed onboarding
          const { data: businesses } = await supabase
            .from("businesses")
            .select("id")
            .eq("user_id", session.user.id)
            .limit(1);

          if (businesses && businesses.length > 0) {
            navigate("/dashboard", { replace: true });
          } else {
            navigate("/onboarding", { replace: true });
          }
        }
      }
    );

    return () => subscription.unsubscribe();
  }, [navigate, location.pathname]);
}
